/**
 * @功能名称:
 * @文件名称: config.js
 * @Date: 2018/8/8 下午9:26.
 * @Author: liux
 * @Copyright（C）: 2014-2018 X-Financial Inc.   All rights reserved.
 */
export default {
  0: {
    home: '首页',
    qa: {
      title: '常见问题',
      url: {title: '常见问题', src: 'https://cardloan.xiaoying.com/fe/pages/qa.html'},
    },
    about: {
      title: '了解小赢卡贷',
      url: {title: '了解小赢卡贷', src: 'https://cardloan.xiaoying.com/fe/pages/whatskdApp.html'}
    }
  },
  1: {
    home: '首页',
    qa: {
      title: '常见问题',
      url: {title: '常见问题', src: 'https://cardloan.xiaoying.com/fe/pages/qaCashLoan.html'},
    },
    about: {
      title: '',
      url: ''
    }
  },
  5: { // 白条
    home: false,
    qa: {
      title: '常见问题',
      url: {title: '常见问题', src: 'https://cardloan.xiaoying.com/fe/pages/qaCashLoan.html'},
    },
    about: {
      title: '',
      url: ''
    }
  },
  10:{
    home: '首页',
    qa: {
      title: '关于信用付',
      url: {title: '关于信用付', src: 'https://cardloan.xiaoying.com/fe/pages/whatskdApp.html'},
    },
    about: {
      title: '',
      url: ''
    },
  },
  11:{
    home: '首页',
    qa: {
      title: '常见问题',
      url: {title: '常见问题', src: 'https://cardloan.xiaoying.com/fe/pages/qaDeYiHua.html'},
    },
    about: {
      title: '',
      url: ''
    },
  },
  15:{
    home: '首页',
    qa: {
      title: '常见问题',
      url: {title: '常见问题', src: 'https://cardloan.xiaoying.com/fe/pages/qaZhongxin.html?partnerName=ZHONGXINAPI2'},
    },
    about: {
      title: '',
      url: ''
    },
    changePhone:{
      title:'更换手机号',
      url: {title: '更换手机号', src: 'https://cardloan.xiaoying.com/fe/cardloan/changePhone/index.html?partnerName=ZHONGXINAPI2'},
    },
    changeBankCard:{
      title:'更换银行卡',
      url: {title: '更换银行卡', src: 'https://cardloan.xiaoying.com/fe/cardloan/changeBankCard/index.html?partnerName=ZHONGXINAPI2'},
    }
  },
  17:{
    home:'首页',
    qa: {
      title: '常见问题',
      url: {title: '常见问题', src: 'https://cardloan.xiaoying.com/fe/pages/qaZhongxin.html?partnerName=ZHONGXINAPI'},
    },
    about: {
      title: '',
      url: ''
    },
    changePhone:{
      title:'更换手机号',
      url: {title: '更换手机号', src: 'https://cardloan.xiaoying.com/fe/cardloan/changePhone/index.html?partnerName=ZHONGXINAPI'},
    },
    changeBankCard:{
      title:'更换银行卡',
      url: {title: '更换银行卡', src: 'https://cardloan.xiaoying.com/fe/cardloan/changeBankCard/index.html?partnerName=ZHONGXINAPI'},
    }
  },
  22:{
    home:'首页',
    qa: {
      title: '常见问题',
      url: {title: '常见问题', src: 'https://cardloan.xiaoying.com/fe/pages/qaZhongxin.html?partnerName=ZHONGXINAPI3'},
    },
    about: {
      title: '',
      url: ''
    },
    changePhone:{
      title:'更换手机号',
      url: {title: '更换手机号', src: 'https://cardloan.xiaoying.com/fe/cardloan/changePhone/index.html?partnerName=ZHONGXINAPI3'},
    },
    changeBankCard:{
      title:'更换银行卡',
      url: {title: '更换银行卡', src: 'https://cardloan.xiaoying.com/fe/cardloan/changeBankCard/index.html?partnerName=ZHONGXINAPI3'},
    }
  },
  26:{
    home: '首页',
    qa: {
      title: '常见问题',
      url: {title: '常见问题', src: 'https://cardloan.xiaoying.com/fe/pages/qaLoan.html?productType=26'},
    },
    about: {
      title: '',
      url: ''
    },
  }
}
